/* eslint-disable no-lone-blocks */
import React, { useEffect } from "react";
import { OktaIDP, AuthenticationState } from "../components/OktaIDP";
import { authProvider } from "../context/authProvider";
import ReactRecaptcha3 from "react-google-recaptcha3";
import { fetchRecapcha } from "../Api/fetchRecapcha";
import { SITE_KEY } from "../utilities";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { getStoredValue, storeValue } from "../storage";
import { BRANDINGS_ICONS } from "../const/brandings";

export const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    ReactRecaptcha3.init(SITE_KEY).then((status) => {
      /* eslint-disable-next-line no-console */
      console.log(status);
    });
  }, []);

  const handleLogin = () => {
    ReactRecaptcha3.getToken().then(
      (token) => {
        //console.log("token de recaptcha",token);
        // send request to backend
        validateRecapcha(token);
      },
      (error) => {
        /* eslint-disable-next-line no-console */
        console.log(error);
      }
    );
  };

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const token = queryParams.get("token");

    /* eslint-disable-next-line no-console */
    console.log("Token recibido:", token);

    if (token) {
      const saveAndLogin = async () => {
        await storeValue("oktatoken", token);
        window.history.replaceState({}, "", location.pathname);
        //loginSaml();
      };
      saveAndLogin();
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [location.search]);

  // TODO PONER EN SERVICIO
  // const loginSaml = async () => {
  //   console.info('Initiating SAML check.', 'SAML');
  //   const fetchUser = async () => {
  //     try {
  //       const token = await getStoredValue("oktatoken");
  //       console.log("fetchUser", token);
  //       const res = await axios({
  //         method: "GET",
  //         url: "https://ch1q6ibky0.execute-api.us-east-1.amazonaws.com/v1/home/okta/whoami",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "Authorization": `Bearer ${token}`
  //         }
  //       });
  //       if (res.status === 200) {
  //         console.log('Usuario autenticado:', res.data);
  //         navigate("/Home", { replace: true });
  //       } else {
  //         console.error('Usuario NO autenticado');
  //       }
  //     } catch (error) {
  //       console.error("Error autenticando usuario:", error);
  //     }
  //   };

  //   fetchUser();
  // };

  const RedirectToLogin = () => {
    window.location.replace(
      "https://ch1q6ibky0.execute-api.us-east-1.amazonaws.com/v1/home/okta?source=inventario"
    );
    // window.location.replace(
    //   "https://ch1q6ibky0.execute-api.us-east-1.amazonaws.com/v1/home/okta?source=web"
    // );
  };

  const validateRecapcha = (token) => {
    //Todo: remover para produccion
    RedirectToLogin();
    // authProvider.login()
    return;

    // const onFailure = (error) => {
    //   console.log("validateRecapcha error", error);
    // };
    // const onSuccess = ({ data }) => {
    //   console.log("respuesta de recaptcha", data);
    //   {
    //     data.statusCode === 200 ? RedirectToLogin() : alert(data.body);
    //   }
    // };
    // fetchRecapcha(token).then(onSuccess).catch(onFailure);
  };

  return (
    <OktaIDP provider={authProvider}>
      {({ authenticationState, error, login }) => {
        const Unauthenticated = authenticationState !== AuthenticationState.Authenticated;
        if (Unauthenticated) {
          return (
            <div className="App-body-login">
              <div className="login-content">
                <div className="login-form">
                  <img className="login-logo" src={BRANDINGS_ICONS.woeLogo} alt="WOE Logo" />

                  <p className="login-title">¡Te damos la bienvenida!</p>

                  <button className="App-login-button" onClick={handleLogin}>
                    Ingresar
                  </button>

                  <a
                    className="avisoprivacidad"
                    href={`/Politicas_de_privacidad`}
                    target="_blank"
                    rel="noreferrer"
                  >
                    Aviso de privacidad
                  </a>
                </div>
              </div>

              <footer className="login-footer">
                <div className="footer-brands">
                  <img src={BRANDINGS_ICONS.allBrands} alt="Marcas" className="brands-logo" />
                </div>

                <div className="footer-separator" />

                <img src={BRANDINGS_ICONS.alseaLogo} alt="Alsea" className="alsea-logo" />
              </footer>
            </div>
          );
        }
        return <Navigate to="/Home" replace />;
      }}
    </OktaIDP>
  );
};
